import * as React from 'react';

import {LockIcon} from 'shells/icon';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {UpgradePillButton} from 'shells/limits/upgrade-pill-button';
import {Radio} from 'shells/radio/radio';

import {ManagedMeetingsFeatureGateModal} from '../../managed-meetings-feature-gate-modal';

import {MANAGED_MEETING} from './create-meeting-modal';

import styles from './meeting-host-type-selection.module.css';

type Props = {
    canAccessManagedMeetings: boolean;
};

export function ManagedMeetingRadioSelect(props: Props) {
    const [isFeatureGateOpen, setIsFeatureGateOpen] = React.useState<boolean>(false);

    return (
        <StackLegacy spacing={20}>
            <Divider variant='line--horizontal' />
            <div className='flex align-center'>
                <div className={props.canAccessManagedMeetings ? '' : 'disabled'}>
                    <Radio
                        value={MANAGED_MEETING}
                        size={15}
                        shouldTopAlignInput={true}
                        shouldWidthFitContent={true}
                        disabled={!props.canAccessManagedMeetings}
                    >
                        <div className={styles['radio-label']}>
                            <LockIcon size={15} wrapWithDiv={false} />
                            <div>Managed</div>
                        </div>
                        <div className={styles['radio-sublabel']}>
                            Create a meeting once, and share it with any number of users and teams
                            for reusability and consistency
                        </div>
                    </Radio>
                </div>
                {!props.canAccessManagedMeetings && (
                    <UpgradePillButton onClick={() => setIsFeatureGateOpen(true)} size='small' />
                )}
            </div>
            <ManagedMeetingsFeatureGateModal
                isOpen={isFeatureGateOpen}
                onClose={() => setIsFeatureGateOpen(false)}
            />
        </StackLegacy>
    );
}
